import { render } from "./CancelSequestrateList.vue?vue&type=template&id=da203512"
import script from "./CancelSequestrateList.vue?vue&type=script&lang=js"
export * from "./CancelSequestrateList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__